import { ESTADOS } from '@/resources/constants';
var ReclamacionMixin = {
  methods: {
    getEstiloTraza(listaEstadosIdTrazas, estadoActualTraza, idActualTraza, estadoActual) {
      var arrIds = [];
      listaEstadosIdTrazas.forEach(item => {
        if (item[0] == estadoActualTraza) {
          arrIds.push(item[1]);
        }
      });
      var size = arrIds.length;
      if ((size > 1 && arrIds[size - 1] == idActualTraza && estadoActualTraza == estadoActual) || (size == 1 && estadoActualTraza == estadoActual)) {
        return 'status-badge status-current'
      } else {
        return 'status-badge status-previous'
      }
    },
    getEstiloRuta(index, grafoRuta, rutaEstado, estadoActual) {
      var arrIndex = [];
      grafoRuta.forEach((item, index) => {
        if (item == rutaEstado) {
          arrIndex.push(index);
        }
      })
      var sizeIndex = arrIndex.length;
      if ((sizeIndex > 1 && arrIndex[sizeIndex - 1] == index && rutaEstado == estadoActual) || (sizeIndex == 1 && rutaEstado == estadoActual)) {
        return 'status-badge-current status-route-product-current'
      } else {
        var indexRutaEstado = grafoRuta.findIndex(estado => estado === rutaEstado);
        var indexEstadoActual = grafoRuta.findIndex(estado => estado === estadoActual);
        return ((indexRutaEstado < indexEstadoActual) ? 'status-badge status-route-product-previous' : 'status-badge status-route-product-pending')
      }
    },
    getEstiloEstadoColor(estadoClave) {
      switch (estadoClave) {
        case ESTADOS.RECUPERADA: return 'status-badge status-badge-listado status-estado-positivo';
        case ESTADOS.SUSPENDIDA: return 'status-badge status-badge-listado status-estado-suspendida';
        case ESTADOS.CANCELADA: return 'status-badge status-badge-listado status-estado-negativo';
        case ESTADOS.EXPIRADA: return 'status-badge status-badge-listado status-estado-negativo';
        default: return 'status-badge status-badge-listado status-estado-neutral';
      }
    },
  }
};
export default ReclamacionMixin;





